// extracted by mini-css-extract-plugin
export var box = "_5n-1";
export var checkboxRow = "_5n-8";
export var checked = "_5n-2";
export var descriptionSpacer = "_5n-a";
export var disabled = "_5n-3";
export var icon = "_5n-6";
export var input = "_5n-0";
export var labelSpacer = "_5n-9";
export var medium = "_5n-5";
export var small = "_5n-4";
export var text = "_5n-7";